import { Appearance } from '@stripe/stripe-js';
import { TOKENS } from '../../styles/tokens';

/**
 * Stripe Appearance API themed from the CPGJobs design tokens so the Payment
 * Element, Link, and Address elements match the app's MUI inputs (cpgTheme.ts:
 * MuiInputBase radius 8, notchedOutline `lineSoft`, focus ring `accentSoft`).
 */
export const appearance: Appearance = {
  theme: 'stripe',
  variables: {
    colorPrimary: TOKENS.accent,
    colorText: TOKENS.ink,
    colorTextSecondary: TOKENS.ink3,
    colorTextPlaceholder: TOKENS.placeholder,
    colorDanger: TOKENS.danger,
    colorBackground: TOKENS.surface,
    fontFamily: 'Inter, sans-serif',
    borderRadius: '8px',
    spacingUnit: '4px',
  },
  rules: {
    '.Input': {
      border: `1.5px solid ${TOKENS.lineSoft}`,
      boxShadow: 'none',
      padding: '12px 14px',
    },
    '.Input:focus': {
      border: `1.5px solid ${TOKENS.ink}`,
      boxShadow: `0 0 0 3px ${TOKENS.accentSoft}`,
    },
    '.Input--invalid': {
      border: `1.5px solid ${TOKENS.dangerBorder}`,
    },
    '.Label': {
      fontWeight: '500',
      color: TOKENS.ink2,
    },
  },
};

/**
 * Reuse the Inter web font that the split-card elements loaded (previously the
 * `fonts` array on the global <Elements> in `src/index.tsx`). Stripe injects
 * this stylesheet inside its iframes so custom-font text renders correctly.
 */
export const fonts = [
  {
    cssSrc: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap',
  },
];
